(function (root) {
  'use strict';
  const ns = root.FKKInsurance = root.FKKInsurance || {};
  const selector = '[name="checkout"], .cart__checkout-button, .btn--checkout, a[href="/checkout"]';

  class InsuranceCheckout {
    constructor(controller, document, navigate) {
      this.controller = controller;
      this.document = document;
      this.navigate = navigate;
      this.pending = null;
      this.navigating = false;
      this.activeButton = null;
      this.originalDisabled = false;
      this.bind();
    }

    bind() {
      this.document.addEventListener('click', (event) => {
        const button = event.target.closest?.(selector);
        if (!button || button.disabled) return;
        this.capture(event);
        this.run(button);
      }, true);
      this.document.addEventListener('submit', (event) => {
        const button = event.submitter;
        const form = event.target;
        const checkoutSubmit = button?.matches(selector) || (!button && ['cart', 'CartDrawer-Form'].includes(form.id));
        if (!checkoutSubmit) return;
        this.capture(event);
        this.run(button || this.document.querySelector(selector));
      }, true);
    }

    capture(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }

    resetAfterReturn() {
      this.pending = null;
      this.navigating = false;
      this.controller.checkingOut = false;
      this.controller.state.busy = false;
      if (this.activeButton?.isConnected) this.activeButton.disabled = this.originalDisabled;
      this.activeButton = null;
    }

    async waitForThemeIdle() {
      const deadline = Date.now() + 10000;
      const debounce = typeof ON_CHANGE_DEBOUNCE_TIMER === 'number' ? ON_CHANGE_DEBOUNCE_TIMER : 300;
      while (Date.now() - this.controller.quantityChangedAt < debounce + 50 ||
             this.document.querySelector('.cart__items--disabled, product-form [type="submit"].loading')) {
        if (Date.now() >= deadline) throw new Error('insurance_cart_pending');
        await new Promise((resolve) => root.setTimeout(resolve, 50));
      }
    }

    run(button) {
      if (this.pending) return this.pending;
      const originalDisabled = button?.disabled;
      this.activeButton = button;
      this.originalDisabled = originalDisabled;
      const controller = this.controller;
      controller.checkingOut = true;
      controller.state.busy = true;
      controller.render();
      if (button) button.disabled = true;
      this.pending = (async () => {
        try {
          await controller.initialized;
          await controller.refreshing;
          if (!controller.api.config) throw new Error('insurance_configuration');
          const version = controller.state.preferenceVersion;
          const enabled = controller.state.enabled;
          let result;
          let settled = false;
          for (let attempt = 0; attempt < 3 && !settled; attempt += 1) {
            await this.waitForThemeIdle();
            const cartRevision = controller.cartRevision;
            result = await controller.api.prepareCheckout(enabled);
            await this.waitForThemeIdle();
            settled = cartRevision === controller.cartRevision;
          }
          if (!settled) throw new Error('insurance_cart_pending');
          if (version !== controller.state.preferenceVersion) throw new Error('insurance_choice_changed');
          controller.state.accept(result.cart, result.sequence);
          controller.state.error = null;
          controller.track('fkk_insurance_checkout_ready', { enabled });
          this.navigating = true;
          this.navigate(controller.rootPath + 'checkout');
        } catch (_) {
          this.navigating = false;
          controller.state.error = 'checkout';
          controller.track('fkk_insurance_error', { stage: 'checkout' });
        } finally {
          if (!this.navigating) {
            controller.checkingOut = false;
            controller.state.busy = false;
            controller.render();
            if (button?.isConnected) button.disabled = originalDisabled;
            this.pending = null;
            this.activeButton = null;
          }
        }
      })();
      return this.pending;
    }
  }

  ns.InsuranceCheckout = InsuranceCheckout;
  if (typeof module !== 'undefined') module.exports = ns;
})(globalThis);
